import { Grid, styled } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import './workFlowItem.css'
import { useApplicationSettings } from 'hooks'

const StyledWorkflowHeader = styled('div')(({ themeColors }) => ({
    background: themeColors?.gradient,
    color: '#ffffff',
    '&:hover': {
        background: themeColors?.secondaryGradient,
        cursor: 'pointer',
    },
}))

const WorkFlowsItems = ({ title, description, onClick, isEnabled }) => {
    const { data: appConfig } = useApplicationSettings()
    const themeColors = appConfig.style?.colors

    return (
        <Grid
            onClick={onClick}
            item
            md={4}
            xs={12}
            spacing={2}
            className={`workflowinnergrid ${
                isEnabled ? 'show-workflow' : 'disable-workflow'
            }`}
            data-ai-explain={`Workflow tile: ${title}`}
            role={isEnabled ? 'button' : undefined}
            tabIndex={isEnabled ? 0 : -1}
            aria-disabled={!isEnabled}
            aria-label={isEnabled ? `${title}. ${description}` : undefined}
            onKeyDown={(e) => {
                if (isEnabled && (e.key === 'Enter' || e.key === ' ')) {
                    e.preventDefault();
                    onClick();
                }
            }}
        >
            <StyledWorkflowHeader
                themeColors={themeColors}
                className={
                    themeColors?.gradient && themeColors?.secondaryGradient
                        ? ''
                        : 'gridtitle'
                }
            >
                <h2>{title}</h2>
            </StyledWorkflowHeader>
            <div className="workflowdescription inActive">
                <Icon name="WorkFlowChart" /> <p>{description}</p>
            </div>
            <div className="workflowdescription active">
                <Icon name="WorkFlowChartSelected" /> <p>{description}</p>
            </div>
        </Grid>
    )
}

export default WorkFlowsItems
